import {Dropdown, Collapse, Modal} from 'bootstrap';
import Flickity from 'flickity';
import AOS from 'aos';
import ModuloBox from './plugins/modulobox.js';
import CookieNotification from "bb-cookie-notification";
import imagesLoaded from 'imagesLoaded';
import Mixitup from 'mixitup';
import axios from 'axios';

// Init Animate On Scroll
AOS.init();

// BenedenBoven cookiescript
new CookieNotification({
    content: 'Naast verse vis hebben wij ook <a href="/privacyverklaring">viscookies</a>.'
});

const submitForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('hidden');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(window.location.href, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            form.innerHTML = '';
        }
    }).catch((exception) => {
        grecaptcha.reset();
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[name="' + error + '"]');
                el.classList.add('is-invalid');
                if(el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }
    });
}

window.submitForm = submitForm;

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// Add and remove class on scroll
if(document.querySelector('.logo')) {
    let scrollpos      = window.scrollY;
    var header         = document.querySelector(".logo");
    const headerHeight = header.offsetHeight;

    const addClassOnScroll    = () => header.classList.add("logo-shrink");
    const removeClassOnScroll = () => header.classList.remove("logo-shrink");

    window.addEventListener('scroll', () => {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll();
        } else {
            removeClassOnScroll();
        }
    });
}

window.addEventListener('DOMContentLoaded', (event) => {
    // Flickity
    if(document.querySelector('.promotions-carousel')) {
        new imagesLoaded(document.querySelector('.promotions-carousel'), (instance) => {
            const flkty = new Flickity( '.promotions-carousel', {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                arrowShape: '',
            });
        });
    }
});

// Youtube custom play btn
setInterval(() => {
    if(document.activeElement instanceof HTMLIFrameElement ){
        document.getElementById('video-cover').style.opacity = 0;
        document.getElementById('video-player').style.opacity = 1;
    }
}, 50);

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', (gallery, index) => {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', (gallery, index) => {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

window.onload = function() {
    var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

    if("IntersectionObserver" in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if(entry.isIntersecting) {
                    entry.target.classList.add("visible");
                    entry.target.style.backgroundImage = 'url("' + entry.target.dataset.backgroundImgReplace + '")';
                    entry.target.classList.remove('lazy-background');
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });

        lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    }

    var lazyImages = [].slice.call(document.querySelectorAll("img.img-lazy"));

    if("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if(entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    //lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove("img-lazy");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to a more compatible method here
    }
};

if (document.querySelector('.filter-container')) {
    let containerEl = document.querySelector('.filter-container');
    let mixer = Mixitup(containerEl, {
        selectors: {
            target: '.filter-item',
            control: '.filter-input'
        },
        controls: {
            enable: false,
            toggleLogic: 'or'
        },
        animation: {
            duration: 300,
            easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)'
        },
        load: {
            filter: extractFiltersFromUrl()
        },
        callbacks: {
            onMixEnd: function(state) {
                let filterValues = [];
                document.querySelectorAll('.filter-items input:checked').forEach(element => {
                    filterValues.push(element.dataset.toggle.replace(/^\./, ''));
                });
                if (filterValues.length > 0) {
                    var queryString = '?filters=' + filterValues.join(',');
                    history.pushState(null, document.title, window.location.pathname + queryString);
                } else {
                    history.pushState(null, document.title, window.location.pathname);
                }

                /*document.querySelector('.collection-count').innerHTML = '(' + Array.from(document.querySelectorAll('.filter-item')).filter(s =>
                    window.getComputedStyle(s).getPropertyValue('display') !== 'none'
                ).length + '/' + document.querySelectorAll('.filter-item').length + ')';*/
            }
        }
    });

    window.addEventListener('popstate', function(event) {
        let filters = extractFiltersFromUrl();
        if (mixer.getState().activeFilter.selector === filters) return;
        mixer.filter(filters);
    });

    function extractFiltersFromUrl() {
        let filters = '.' + location.search.replace(/^\?filters=/, '').replace(/,/g, ',.');

        if (filters === '.') {
            filters = '.filter-item';
        }

        document.querySelectorAll('.filter-input').forEach(filterItem => {
            filterItem.checked = false;
        });

        filters.split(',.').forEach((filterItem, i) => {
            if (filterItem !== '') {
                filterItem = (!filterItem.startsWith('.') ? '.' : '') + filterItem;
                if (document.querySelector('.filter-input[data-toggle="' + filterItem + '"]')) {
                    document.querySelector('.filter-input[data-toggle="' + filterItem + '"]').checked = true;
                }
            }
        });

        return filters;
    }

    // Search filter
    if(document.getElementById('filter-search')) {
        document.getElementById('filter-search').addEventListener('keyup', e => {
            e.preventDefault();
            updateFilter();
        });
    }

    document.querySelectorAll('.filter-items input').forEach(element => {
        element.addEventListener('change', e => {
            e.preventDefault();
            updateFilter();
        });
    });

    function updateFilter() {
        let searchQuery = document.getElementById('filter-search').value;

        let ands = [];
        let ors = [];
        document.querySelectorAll('.filter-items input:checked').forEach(element => {
            if (element.dataset['action'] === 'or') {
                ors.push(element.dataset.toggle);
            } else if (element.dataset['action'] === 'and') {
                ands.push(element.dataset.toggle);
            }
        });

        if (ands.length > 0 && ors.length > 0) {
            for (let i in ands) {
                for (let u in ors) {
                    ors[u] = ands[i] + ors[u];
                }
            }
        }

        let filterString = '';
        if (ors.length === 0 && ands.length > 0) {
            filterString = ands.join('');
        } else {
            filterString = ors.join(', ');
        }

        filterString = filterString === '' ? 'all' : filterString;
        filterString = filterString === 'all' && searchQuery === '' ? 'all' : filterString;

        let elements = Array.from(document.querySelectorAll((filterString !== 'all' ? filterString : '.filter-item')));
        let filtered = elements.filter(target => {
            let regex = new RegExp(searchQuery.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$]/g, "\\$&"), 'gi');
            return target.getAttribute('data-search').match(regex);
        });

        mixer.filter(filtered);
    }
}
